import { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";

function App() {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedGirl, setSelectedGirl] = useState(null);

  // Check for userId parameter in URL and save to sessionStorage
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('userId');
    
    if (userId) {
      sessionStorage.setItem('_userIdParam', userId);
      sessionStorage.setItem('_sourceid', userId);
    }
  }, []);

  const handleStep1Yes = () => {
    setCurrentStep(2);
  };

  const handleStep1No = () => {
    window.location.href = "https://lovescape.com";
  };

  const handleGirlSelect = (girl) => {
    setSelectedGirl(girl);
    setCurrentStep(3);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <div className="onboarding-container">
                {currentStep === 1 && (
                  <Step1 onYes={handleStep1Yes} onNo={handleStep1No} />
                )}
                {currentStep === 2 && (
                  <Step2 onSelectGirl={handleGirlSelect} />
                )}
                {currentStep === 3 && (
                  <Step3 selectedGirl={selectedGirl} />
                )}
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
